module.exports = __webpack_public_path__ + "img/tarj3-3.0edfea9e.svg";